<template>
	<div class="preloader">
		<img :src="image" alt="Bleeding Edge logo preloader" />
	</div>
</template>

<script>

export default {
	name: 'Preloader',
	data() {
		return {
			image: require('@/assets/images/preloader.gif')
		}
	}
}
</script>

<style lang="scss">
.preloader {
	width: 100%;
	height: 100%;
	background: black;
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	z-index: 100;

	img {
		max-width: 200px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate3d(-50%, -50%, 0);
	}
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Preloader.vue